//third-party
import parse from "html-react-parser";

export default function PageViewer({ content }) {
	return parse(content);
}
